import { DcSccBaseFactory } from 'dc-scc';

export class BaseFactory extends DcSccBaseFactory
{
	protected async newRequest()
	{
		var reqObj	= await this.getService().newRequest();
		return reqObj;
	}
}